import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface AdiOrderDetailsJobNameStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    JobName?: TypographyProps;
}

export const adiOrderDetailsJobNameStyles: AdiOrderDetailsJobNameStyles = {
    titleText: {
        variant: "p",
    },
};

const styles = adiOrderDetailsJobNameStyles;

const ADIOrderDetailsJobName: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    const titleTextStyle = () => css`
        color: ${order?.properties["jobName"] === "" ? ADIColors.gray3 : getColor("text.main")};
        @media print {
            font-size: 14px;
            color: ${ADIColors.black};
        }
        margin-bottom: 5px;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.13;
    `;

    const JobNameStyle = () => css`
        color: ${order?.properties["jobName"] === "" ? ADIColors.gray3 : getColor("text.main")};
        font-size: 16px;
        text-transform: capitalize;
        line-height: 1.43;
        @media print {
            font-size: 13px;
            color: ${ADIColors.black};
        }
    `;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} css={titleTextStyle()}>
                {translate("Job Name")}
            </Typography>
            <Typography {...styles.JobName} css={JobNameStyle()}>
                {order?.properties["jobName"] === "" ? translate("N/A") : order?.properties["jobName"]?.toLowerCase()}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ADIOrderDetailsJobName,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
